import axiosAuth from '@/shared/configs/axios-auth'

const getDefaultState = () => {
    return {
        darkMode: true,
        colorSchemeSetByUser: '',
        preferedColorScheme: null,
        storeTest: '',
        popLogin: false,
        updating: false,
        kw: null,
        allergens: [],
        additives: [],
        showUi: true,
        fullscreen: false,
    }
}

const state = getDefaultState()

const getters = {
    storeTest: state => {
        return state.storeTest
    },
    preferedColorScheme: state => {
        return state.preferedColorScheme
    },
    darkMode: state => {
        return state.darkMode;
    },
    kw: state => {
        return state.kw;
    },
    colorSchemeSetByUser: state => {
        return state.colorSchemeSetByUser
    },
    testAccess: state => {
        return state.testAccess
    },
    popLogin: state => {
        return state.popLogin
    },
    updating: state => {
        return state.updating
    },
    allergens: state => {
        return state.allergens
    },
    additives: state => {
        return state.additives
    },
    showUi: state => {
        return state.showUi
    },
    fullscreen: state => {
        return state.fullscreen
    }
}

const mutations = {
    storeTest (state, payload) {
        state.storeTest = payload
    },
    kw (state, payload) {
        state.kw = payload
    },
    resetState (state) {
        Object.assign(state, getDefaultState())
    },
    asideToggled: (state, payload) => {
        state.asideToggled = payload
    },
    testAccess: (state, payload) => {
        state.testAccess = payload
    },
    preferedColorScheme: (state, colorScheme) => {
        state.preferedColorScheme = colorScheme
    },
    darkMode: (state, colorScheme) => {
        state.darkMode = colorScheme
    },
    colorSchemeSetByUser: (state, colorScheme) => {
        state.colorSchemeSetByUser = colorScheme
    },
    popLogin: (state, payload) => {
        state.popLogin = payload
    },
    updating: (state, payload) => {
        state.updating = payload
    },
    allergens: (state, payload) => {
        state.allergens = payload
    },
    additives: (state, payload) => {
        state.additives = payload
    },
    showUi: (state, payload) => {
        state.showUi = payload
    },
    fullscreen: (state, payload) => {
        state.fullscreen = payload
    },
}

const actions = {
    resetToasts: ({commit}) => {
        commit('shiftmodelUpdated', null)
    },

    setTheme: ({commit, dispatch}, colorScheme) => {
        commit('colorSchemeSetByUser', colorScheme)
        dispatch('preferedColorScheme')
    },
    darkMode: ({commit}) => {
        commit('darkMode')
    },
    preferedColorScheme: ({commit}) => {
        const preferedColorScheme = window.matchMedia("(prefers-color-scheme: dark)")
        if(!state.colorSchemeSetByUser){
            if (preferedColorScheme.matches) {
                commit('darkMode', true)
            } else {
                commit('darkMode', false)
            }
        }else{
            if(state.colorSchemeSetByUser == 'dark'){
                commit('darkMode', true)
            }else{
                commit('darkMode', false)
            }
        }
    },
    getAllergens: ({commit}) =>{
        commit('updating', true)
        axiosAuth.get('allergens')
        .then(
            res => {
                commit('allergens', res.data)
                commit('updating', false)
            }
          )
          .catch(
            error => {
              console.log(error.response)
            }
          )
    },
    getAdditives: ({commit}) =>{
        commit('updating', true)
        axiosAuth.get('additives')
        .then(
            res => {
                commit('additives', res.data)
                commit('updating', false)
            }
          )
          .catch(
            error => {
              console.log(error.response)
            }
          )
    },
}

export default {
    state,
    getters,
    mutations,
    actions
}